import { Controller } from "@hotwired/stimulus"

const COOKIE = "fitnito_show_attendees"
const MAX_AGE = 60 * 60 * 24 * 365

// Remembers whether the class-details "Who's going" list is open.
// The server also reads this cookie so a Turbo replace doesn't flash the wrong state.
export default class extends Controller {
  persist() {
    const value = this.element.open ? "1" : "0"
    const secure = window.location.protocol === "https:" ? "; secure" : ""
    document.cookie = `${COOKIE}=${value}; path=/; max-age=${MAX_AGE}; samesite=lax${secure}`
  }
}
